import { methodSteps } from "@/mocks/chigua";

export default function MethodSection() {
  return (
    <section id="method" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <div className="flex items-center gap-2 text-primary-600 text-sm font-medium mb-2">
              <span className="w-8 h-0.5 bg-primary-500 rounded-full"></span>
              我们的复盘方法
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
              前因后果 · 三步看清整场瓜
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">
            复盘不是简单复述,而是把事件放回语境中,拆解每一层因果,让你看清事件全貌。
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-5">
          {methodSteps.map((s, i) => (
            <article
              key={s.no}
              className={
                "relative rounded-xl p-6 md:p-7 overflow-hidden " +
                (i === 1
                  ? "bg-accent-100/80"
                  : i === 2
                    ? "bg-secondary-100/80"
                    : "bg-primary-100/80")
              }
            >
              <span className="absolute -right-2 -top-6 font-heading text-[88px] md:text-[104px] font-black leading-none text-foreground-950/5 select-none">
                {s.no}
              </span>
              <div className="relative">
                <span
                  className={
                    "w-11 h-11 rounded-lg flex items-center justify-center text-xl " +
                    (i === 1
                      ? "bg-accent-500 text-background-50"
                      : i === 2
                        ? "bg-secondary-600 text-background-50"
                        : "bg-primary-500 text-background-50")
                  }
                >
                  <i className={s.icon} aria-hidden="true"></i>
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mt-5">{s.title}</h3>
                <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{s.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}